import { render, staticRenderFns } from "./BodyFooter.vue?vue&type=template&id=7fd098f7&scoped=true"
import script from "./BodyFooter.vue?vue&type=script&lang=js"
export * from "./BodyFooter.vue?vue&type=script&lang=js"
import style0 from "./BodyFooter.vue?vue&type=style&index=0&id=7fd098f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd098f7",
  null
  
)

export default component.exports